const clearBtns = [].slice.call(document.querySelectorAll('[data-clear-form]')) as HTMLButtonElement[];
clearBtns.forEach(btn => {
    const parentForm = btn.form;
    if (parentForm) {
        const formElements = [].slice.call(parentForm.elements);
        btn.addEventListener('click', () => {
            formElements.forEach(formElement => {
                if (formElement.nodeName === "INPUT") {
                    (formElement as HTMLInputElement).setAttribute('value', '');
                    formElement.focus();
                }
            });
        });
    }
})